"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBonusesByPromocode = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var CURRENT_CURRENCY = 'current_currency_by_type';
var CURRENT_LANG = 'current_lang';
var CURRENT_PROMOCODE = 'current_promo_code';
var useBonusesByPromocode = function (bonusType, code) {
    var _a = (0, useCache_1.useCache)(), getDataFromCache = _a.getDataFromCache, setDataToCache = _a.setDataToCache;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var _b = (0, useQuery_1.useQuery)({
        path: keys_1.BONUSES_BY_PROMOCODE,
        payload: { bonusType: bonusType, currency: currentCurrency, lang: lang, code: code },
        revalidateOnMount: true,
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, mutate = _b.mutate, isValidating = _b.isValidating;
    (0, react_1.useEffect)(function () {
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        var prevLang = getDataFromCache(CURRENT_LANG);
        var prevPromocode = getDataFromCache(CURRENT_PROMOCODE);
        if (prevCurrency !== currentCurrency ||
            prevLang !== lang ||
            prevPromocode !== code) {
            mutate();
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
            setDataToCache(CURRENT_LANG, lang);
            setDataToCache(CURRENT_PROMOCODE, code);
        }
    }, [lang, code, currentCurrency, getDataFromCache, setDataToCache, mutate]);
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || { bonuses: [], promoId: '' },
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    }); }, [data, isLoading, isValidating, error]);
};
exports.useBonusesByPromocode = useBonusesByPromocode;
